import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon, PhoneIcon, CompassIcon } from 'lucide-react';
import { FEATURED_SERVICES } from '../../lib/services';
import { FIRM } from '../../lib/constants';
import { Container } from '../ui/Container';
import { SectionHeading } from '../ui/SectionHeading';
export function FeaturedServices() {
  return <section className="bg-white py-16 lg:py-24" data-id="element-80">
      <Container data-id="element-81">
        <SectionHeading align="center" eyebrow="Our practice areas" title="Serious legal capability, explained simply." intro="Each practice area has its own dedicated team and landing page. Explore what we do, or speak directly to the right people." data-id="element-82" />

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-83">
          {FEATURED_SERVICES.map((s, i) => <motion.article key={s.slug} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.35,
          delay: i % 3 * 0.06
        }} className="group flex flex-col rounded-xl border border-navy/10 bg-cream p-6 transition-all duration-200 hover:-translate-y-0.5 hover:border-brass/40 hover:shadow-card-hover" data-id="element-84">
              <h3 className="font-serif text-xl leading-snug text-navy" data-id="element-85">
                {s.title}
              </h3>
              <p className="mt-2 text-sm font-medium text-brass-dark" data-id="element-86">
                {s.short}
              </p>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-ink/60" data-id="element-87">
                {s.description}
              </p>
              <div className="mt-5 flex items-center gap-4 border-t border-navy/10 pt-4 text-sm font-medium" data-id="element-88">
                <Link to={`/services/${s.slug}`} className="inline-flex items-center gap-1 text-navy transition-colors group-hover:text-brass-dark" data-id="element-89">
                  Learn more
                  <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-0.5" data-id="element-90" />
                </Link>
                <a href={FIRM.phoneHref} className="ml-auto inline-flex items-center gap-1 text-ink/50 hover:text-brass-dark" data-id="element-91">
                  <PhoneIcon className="h-3.5 w-3.5" data-id="element-92" />
                  Speak to this team
                </a>
              </div>
            </motion.article>)}

          {/* 9th card — completes the 3x3 grid & drives conversion */}
          <motion.article initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.35,
          delay: 0.12
        }} className="group flex flex-col justify-between rounded-xl border border-brass/40 bg-navy p-6 text-cream transition-all duration-200 hover:-translate-y-0.5 hover:shadow-card-hover" data-id="element-93">
            <div data-id="element-94">
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-cream/10" data-id="element-95">
                <CompassIcon className="h-5 w-5 text-brass-light" data-id="element-96" />
              </span>
              <h3 className="mt-4 font-serif text-xl leading-snug text-cream" data-id="element-97">
                Not sure which area you need?
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-cream/75" data-id="element-98">
                Tell us what has happened and we'll match you with the right
                team — no obligation, completely confidential.
              </p>
            </div>
            <div className="mt-6 flex items-center gap-4 border-t border-cream/10 pt-4 text-sm font-medium" data-id="element-99">
              <Link to="/enquiry" className="inline-flex items-center gap-1 text-brass-light transition-colors hover:text-brass" data-id="element-100">
                Start here
                <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-0.5" data-id="element-101" />
              </Link>
              <a href={FIRM.phoneHref} className="ml-auto inline-flex items-center gap-1 text-cream/60 hover:text-cream" data-id="element-102">
                <PhoneIcon className="h-3.5 w-3.5" data-id="element-103" />
                {FIRM.phoneDisplay}
              </a>
            </div>
          </motion.article>
        </div>
      </Container>
    </section>;
}